import React from "react";
import { Linkedin, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const leaders = [{
  name: "Carlos Ramirez",
  title: "Executive Director",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1214114/img/carlos_ramirez_headshot.png",
  linkedin: "https://linkedin.com",
  bioLink: "#"
}, {
  name: "Ana Lopez",
  title: "Program Director",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1214114/img/ana_lopez_headshot.png",
  linkedin: "https://linkedin.com",
  bioLink: "#"
}, {
  name: "Sofia Martinez",
  title: "Board Chair",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1214114/img/sofia_martinez_headshot.png",
  linkedin: "https://linkedin.com",
  bioLink: "#"
}, {
  name: "Mateo Rivera",
  title: "Treasurer",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1214114/img/mateo_rivera_headshot.png",
  linkedin: "https://linkedin.com",
  bioLink: "#"
}];
export default function ExecutiveLeadership() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="executive-leadership" ref={ref} className={`py-24 bg-background transition-opacity duration-700 ${isVisible ? "opacity-100" : "opacity-0"}`}>
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold font-serif text-primary mb-6">
            Executive Leadership
          </h2>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto font-sans">
            Guided by a commitment to economic equity and community empowerment,
            our leadership team brings decades of experience in nonprofit
            management, business development, and advocacy.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {leaders.map((leader, i) => <div key={i} data-index={i} className="group">
              <Card className="h-full border-none shadow-none bg-transparent overflow-visible">
                <CardContent className="p-0">
                  {}
                  <div className="relative overflow-hidden rounded-xl aspect-[3/4] mb-6 shadow-lg">
                    <img src={leader.image} alt={leader.name} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
                    
                    {}
                    <div className="absolute bottom-0 left-0 right-0 h-2 bg-secondary/80 z-10" />

                    {}
                    <div className="absolute inset-0 bg-primary/90 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col items-center justify-center gap-4 z-20 p-6 text-center">
                      <Link to={leader.linkedin} newTab aria-label={`${leader.name}'s LinkedIn`}>
                        <div className="p-3 bg-white/10 rounded-full hover:bg-secondary hover:text-primary-foreground text-white transition-colors duration-300">
                          <Linkedin className="size-6" />
                        </div>
                      </Link>
                      
                      <Button asChild variant="outline" className="border-secondary text-secondary hover:bg-secondary hover:text-primary font-sans tracking-wide uppercase text-xs font-bold">
                        <Link to={leader.bioLink}>
                          View Bio
                        </Link>
                      </Button>
                    </div>
                  </div>

                  {}
                  <div className="text-center">
                    <h3 className="text-2xl font-bold font-serif text-primary mb-2 group-hover:text-secondary transition-colors duration-300">
                      {leader.name}
                    </h3>
                    <p className="text-secondary font-sans font-medium uppercase tracking-wider text-sm">
                      {leader.title}
                    </p>
                  </div>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}